"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadPageLink = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const StyledLink = (0, styled_components_1.default)(base_react_components_1.Link).withConfig({ displayName: "reports-StyledLink", componentId: "reports-bb4pks" }) `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 50%;
  border-width: 0;
  & > ${base_react_components_1.Icon} {
    margin-right: 8px;
  }
`;
const onLoadHack = document.createElement('img');
const DownloadPageLink = ({ to, text = 'Download full report', }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    onLoadHack.onload = () => {
        setIsLoading(false);
    };
    onLoadHack.onerror = () => {
        setIsLoading(false);
    };
    return (react_1.default.createElement(StyledLink, { "data-testid": "global:download:download-button", href: to, download: true, target: "_self", onClick: () => {
            onLoadHack.src = to;
            setIsLoading(true);
        } }, isLoading ? (react_1.default.createElement(base_react_components_1.LoadingDots, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(base_react_components_1.Icon, { name: "actions/cloud-download" }),
        react_1.default.createElement(base_react_components_1.Text, null, text)))));
};
exports.DownloadPageLink = DownloadPageLink;
exports.default = exports.DownloadPageLink;
//# sourceMappingURL=index.js.map